import React from 'react'
import Popover from '@material-ui/core/Popover'
import Typography from '@material-ui/core/Typography'
import {
  Link,
  Theme,
  Table,
  IconButton,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import messages from '../../messages'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import MuiDialogContent from '@material-ui/core/DialogContent'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import CloseIcon from '@material-ui/icons/Close'

const useStyles = makeStyles((theme) => ({
  typography: {
    padding: theme.spacing(0),
  },
  tableBody: {
    backgroundColor: '#ffffff',
    padding: theme.spacing(1),
  },
  tableBodyForKictSym: {
    backgroundColor: '#ffffff',
    padding: theme.spacing(1),
    color: '#00f300',
    fontWeight: 'bolder',
  },
  rootRow: {
    fontWeight: theme.typography.fontWeightMedium,
    padding: theme.spacing(2),
    backgroundColor: '#F2F3F4',
    width: '20%',
    borderBottom: 'hidden',
  },
  rootRowBorderHidden: {
    fontWeight: theme.typography.fontWeightMedium,
    padding: theme.spacing(2),
    backgroundColor: '#F2F3F4',
    width: '20%',
    borderBottom: 'hidden',
  },
  lightGreyFont: {
    color: '#787878',
    borderBottom: 1,
    fontSize: theme.typography.pxToRem(12),
  },
  table: {
    minWidth: 800,
    padding: theme.spacing(1),
    left: theme.spacing(0),
  },
  root: {
    margin: 0,
    marginTop: '10.5px',
  },
  clearButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
  styleLink: {
    color: theme.palette.primary.main,
  },
  iconCheck: {
    paddingLeft: theme.spacing(2),
    fontSize: theme.typography.pxToRem(30),
    fontWeight: theme.typography.fontWeightMedium,
    color: '#13cee1',
  },
}))
export interface DialogTitleProps {
  id: string
  children: React.ReactNode
  onClose: () => void
}

const DialogTitle = (props: DialogTitleProps): JSX.Element => {
  const { children, onClose, ...other } = props
  const classes = useStyles()
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.clearButton}
          onClick={onClose}
          color="primary"
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  )
}

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent)

const CrisprgrnaRecommendationPopUp = () => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const handleClick = (event): void => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (): void => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'modified-popover' : undefined
  const topChoice2 = '\u2713'
  function createData(blank, crRNA, sgRNA, modifiedcrRNA, modifiedsgRNA) {
    return { blank, crRNA, sgRNA, modifiedcrRNA, modifiedsgRNA }
  }

  const rows = [
    createData(
      'Easy-to-transfect cells',
      `${topChoice2}`,
      `${topChoice2}`,
      `${topChoice2}`,
      `${topChoice2}`
    ),
    createData(
      'Hard-to-transfect cells',
      '',
      '',
      `${topChoice2}`,
      `${topChoice2}`
    ),
    createData('Primary cells', '', '', `${topChoice2}`, `${topChoice2}`),
    createData(
      'Animal embroys',
      `${topChoice2}`,
      `${topChoice2}`,
      `${topChoice2}`,
      `${topChoice2}`
    ),
  ]

  return (
    <>
      <Link
        component="button"
        underline={'hover'}
        onClick={handleClick}
        className={classes.styleLink}
      >
        <i>
          <FormattedMessage {...messages.CUSTOM_CRISPR_RECOMMENDATIONS} />
        </i>
      </Link>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Typography className={classes.typography}>
          <DialogTitle id="customized-dialog-title" onClose={handleClose}>
            <b> </b>
          </DialogTitle>
          <DialogContent dividers>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell
                    align="left"
                    className={classes.rootRow}
                  ></TableCell>
                  <TableCell align="center" className={classes.rootRow}>
                    <FormattedMessage
                      {...messages.CUSTOM_CRISPR_CRRNA_POPUP_customcrispr}
                    />
                  </TableCell>
                  <TableCell align="center" className={classes.rootRow}>
                    <FormattedMessage
                      {...messages.CUSTOM_CRISPR_SGRNA_POPUP_customcrispr}
                    />
                  </TableCell>
                  <TableCell align="center" className={classes.rootRow}>
                    <FormattedMessage
                      {...messages.CUSTOM_CRISPR_MOD_SGRNA_POPUP_customcrispr}
                    />
                  </TableCell>
                  <TableCell align="center" className={classes.rootRow}>
                    <FormattedMessage
                      {...messages.CUSTOM_CRISPR_MOD_CRRNA_POPUP_customcrispr}
                    />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, index) => (
                  <TableRow className={classes.rootRow} key={index}>
                    <TableCell align="left" className={classes.tableBody}>
                      {row.blank}
                    </TableCell>
                    <TableCell
                      align="center"
                      className={classes.tableBodyForKictSym}
                    >
                      {row.crRNA}
                    </TableCell>
                    <TableCell
                      align="center"
                      className={classes.tableBodyForKictSym}
                    >
                      {row.sgRNA}
                    </TableCell>
                    <TableCell
                      align="center"
                      className={classes.tableBodyForKictSym}
                    >
                      {row.modifiedcrRNA}
                    </TableCell>
                    <TableCell
                      align="center"
                      className={classes.tableBodyForKictSym}
                    >
                      {row.modifiedsgRNA}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </DialogContent>
        </Typography>
      </Popover>
    </>
  )
}
export default CrisprgrnaRecommendationPopUp
